import React from "react";
import ReactDOM from "react-dom";
import "./styles.css"; // Import global CSS
import App from "./app";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

